module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tw-h-full noselect"
  }, [_c('div', {
    staticClass: "tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tw-text-2xl tw-font-thin tw-text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.errorMessage)
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fa-stack fa-3x tw-mb-5"
  }, [_c('span', {
    staticClass: "fa-solid fa-circle fa-stack-2x tw-text-amber-50"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa-duotone fa-triangle-exclamation fa-stack-1x fa-inverse tw-text-amber-500"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6218d8b4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ecranErreur/erreurEcran.vue.html
// module id = nai1
// module chunks = 2